<div class="skeelo-dashboard-page">
  <h1 class="page-title">Skeelo</h1>

  <section class="metrics-grid">
    <article class="metric-card" *ngFor="let metric of metricCards">
      <span class="metric-label">{{ metric.label }}</span>
      <strong class="metric-value">{{
        getMetricValue(metric.key) | number: '1.0-0'
      }}</strong>
    </article>
  </section>

  <section class="filter-card">
    <div class="filter-header">
      <h2>Filtros</h2>
    </div>

    <div class="filter-content">
      <div class="filter-field">
        <label for="selectedMonth"
          >Selecione um mês - com base na EditionId (Ano|Mês):</label
        >
        <p-dropdown
          inputId="selectedMonth"
          [options]="months"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          [(ngModel)]="selectedMonth"
          (onChange)="onMonthChange()"
        ></p-dropdown>
      </div>
    </div>
  </section>

  <section class="dashboard-block chart-block">
    <div class="block-header">
      <h2>Benefícios no mês de {{ selectedMonthName | titlecase }}</h2>
    </div>

    <div class="chart-wrapper">
      <p-chart
        type="line"
        [data]="chartData"
        [options]="chartOptions"
      ></p-chart>
    </div>

    <div class="details-table-wrapper">
      <app-table
        [elements]="chartDetails"
        [addButton]="false"
        [cols]="chartDetailsCols"
        emptyMessage="Nenhum plano encontrado para o mês selecionado."
        [exportExcel]="true"
        [exportPdf]="true"
        [lazy]="false"
        [defaultRows]="20"
        sortField="planCode"
        [sortOrder]="1"
        [changeColumns]="true"
        [showTitle]="false"
        modelName="planos"
      ></app-table>
    </div>
  </section>

  <section class="dashboard-block">
    <div class="block-header">
      <h2>Buscar benefícios do assinante</h2>
    </div>

    <div class="subscriber-search-fields">
      <span class="p-float-label">
        <p-inputNumber
          inputId="personId"
          [useGrouping]="false"
          [(ngModel)]="subscriberFilters.personId"
        ></p-inputNumber>
        <label for="personId">PersonId</label>
      </span>

      <span class="p-float-label">
        <p-inputNumber
          inputId="subscriberId"
          [useGrouping]="false"
          [(ngModel)]="subscriberFilters.subscriberId"
        ></p-inputNumber>
        <label for="subscriberId">SubscriberId</label>
      </span>

      <span class="p-float-label">
        <input
          pInputText
          inputId="email"
          type="email"
          [(ngModel)]="subscriberFilters.email"
        />
        <label for="email">E-mail</label>
      </span>

      <span class="p-float-label">
        <input
          pInputText
          inputId="boxId"
          [(ngModel)]="subscriberFilters.boxId"
        />
        <label for="boxId">BoxId</label>
      </span>

      <p-button
        label="Buscar"
        [disabled]="!canSearchSubscribers"
        (onClick)="searchSubscribers()"
      ></p-button>
    </div>

    <ng-container *ngIf="subscriberSearched">
      <ng-container *ngIf="subscribers.length > 0; else noSubscribersFound">
        <p-table
          [value]="subscribers"
          styleClass="p-datatable-sm p-datatable-striped"
          [scrollable]="true"
          scrollHeight="220px"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>PersonId</th>
              <th>SubscriberId</th>
              <th>Nome</th>
              <th>Assinatura</th>
              <th>Status</th>
              <th></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-subscriber>
            <tr>
              <td>{{ subscriber.personId || '-' }}</td>
              <td>{{ subscriber.subscriberId || '-' }}</td>
              <td>{{ subscriber.shippingName || '-' }}</td>
              <td>{{ subscriber.subscriptionName || '-' }}</td>
              <td>{{ subscriber.status || '-' }}</td>
              <td>
                <p-button
                  *ngIf="
                    selectedSubscriber?.subscriberId !== subscriber.subscriberId
                  "
                  label="Selecionar"
                  severity="secondary"
                  size="small"
                  (onClick)="selectSubscriber(subscriber)"
                ></p-button>
                <p-button
                  *ngIf="
                    selectedSubscriber?.subscriberId === subscriber.subscriberId
                  "
                  label="Selecionado"
                  severity="success"
                  size="small"
                  [disabled]="true"
                ></p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </ng-container>

      <ng-template #noSubscribersFound>
        <p class="no-results">Nenhum assinante encontrado.</p>
      </ng-template>
    </ng-container>

    <div class="selected-subscriber" *ngIf="selectedSubscriber">
      <span>
        <strong>Assinante selecionado:</strong>
        {{ selectedSubscriber.shippingName || '-' }} - PersonId:
        {{ selectedSubscriber.personId || '-' }}
      </span>
      <p-button
        icon="pi pi-times"
        severity="danger"
        [rounded]="true"
        [text]="true"
        size="small"
        type="button"
        (onClick)="clearSelectedSubscriber()"
      ></p-button>
    </div>

    <div class="details-table-wrapper" *ngIf="selectedSubscriber">
      <app-table
        [elements]="personBenefitsData"
        [addButton]="false"
        [cols]="personBenefitsCols"
        emptyMessage="Nenhum benefício encontrado para o assinante selecionado."
        [exportExcel]="true"
        [exportPdf]="true"
        [lazy]="false"
        [defaultRows]="20"
        sortField="dateCreated"
        [sortOrder]="-1"
        [changeColumns]="true"
        [showTitle]="false"
        modelName="benefícios"
      ></app-table>

      <p class="no-results" *ngIf="!hasPersonBenefits">
        Nenhum benefício encontrado para o assinante selecionado.
      </p>
    </div>
  </section>
</div>
